import { connect } from 'react-redux';
import Actions from '../../actions';
import BaseMenu from '../base/base-menu';

import HeaderMenu from '../../components/shared/header/header-menu';

const mapStateToProps = (state, ownProps) => ({
    currentStore: state.currentStore,
    availableZones: state.zones.availableZones,
    currentZone: state.zones.currentZone,
    availableMunicipalities: state.municipalities.availableMunicipalities,
    currentMunicipality: state.municipalities.currentMunicipality,
    isMunicipalityPromptModalOpen: state.municipalities.isMunicipalityPromptModalOpen,
});

const mapDispatchToProps = (dispatch) => ({
    setCurrentStore: (store) => {
        dispatch(Actions.setCurrentStore(store));
    },
    setCurrentMunicipality: (municipalityId) => {
        dispatch(Actions.setCurrentMunicipality(municipalityId));
    },
});

const HeaderMenuConnector = connect(mapStateToProps, mapDispatchToProps)(HeaderMenu);

export default BaseMenu(HeaderMenuConnector);



/** WEBPACK FOOTER **
 ** ./src/containers/menus/header-menu-connector.js
 **/